<template>
  <div class="w-full h-full relative text-center m-0 p-0">
    <div class="fixed w-full z-10 text-center">
      <img class="w-full lg:mt-24 inline sm:hidden" src="@/assets/banner.jpg" />
    </div>
    <div class="relative w-full h-full text-center overflow-y-auto pb-14">
      <header class="main-dashboard-header">
        <div>
          <span class="main-dashboard-header__kicker">Hauptbereich</span>
          <h1 class="main-dashboard-header__title">Übersicht</h1>
          <p class="main-dashboard-header__subtitle">
            Wählen Sie einen Bereich aus, um fortzufahren.
          </p>
        </div>
        <div class="main-dashboard-header__icon" aria-hidden="true">
          <i class="fa fa-house"></i>
        </div>
      </header>

      <Spinner v-if="loading" />

      <div
        class="relative w-full text-center pt-[37%] sm:pt-4 xl:w-1/2 xl:inline-block"
      >
        <div v-if="offline" class="pb-4 px-4">
          <span
            class="px-2 py-1 bg-red-500 rounded inline-block font-bold underline "
            
            >Du bist aktuell offline, der Funktionsumfang der App ist
            eingeschränkt.</span
          ><br />
          <button class="bg-caspyellow text-black mt-2" @click="getStats()">
            Verbinden
          </button>
        </div>
        <div v-if="stats.impersonating" class="pb-4 px-4">
          <span
            class="px-2 py-1 bg-caspyellow rounded inline-block font-bold"
            >Admin-Modus: Sie verwenden die Identität von
            {{ stats.user.name }}.</span
          >
        </div>
        <div v-if="stats.currentJob" class="pb-4 px-4">
          <span
            class="px-2 py-1 bg-caspyellow rounded inline-block font-bold underline cursor-pointer"
            @click="
              $router.push({
                name: 'Jobdetails',
                params: { jobid: stats.currentJob.id },
              })
            "
            >Zum aktuellen Auftrag:
            {{ stats.currentJob.Vertragsbeschreibung }}</span
          >
        </div>
        <div
          v-if="!offline"
          class="dashboardtile"
          onclick="window.location='/jobs'"
        >
          <i class="far fa-clipboard fa-2x pt-2" /><br />
          <span class="inline-block pb-2 align-middle text-lg">Aufträge</span>
          <span
            v-if="stats.jobs > 0"
            class="bg-red-500 rounded-full absolute p-1 -top-2 -right-2"
            >{{ stats.jobs }}</span
          >
        </div>
        <div
          v-if="
            !offline && stats.permissions && stats.permissions.internalDispo
          "
          class="dashboardtile"
          onclick="window.location='/tasks'"
        >
          <i class="fa fa-list-check fa-2x pt-2" /><br />
          <span class="inline-block pb-2 align-middle text-lg">Aufgaben</span>
          <span
            v-if="stats.tasks > 0"
            class="bg-red-500 rounded-full absolute p-1 -top-2 -right-2"
            >{{ stats.tasks }}</span
          >
        </div>
        <div
          v-if="!offline"
          class="dashboardtile"
          onclick="window.location='/chat'"
          :class="{ 'md:hidden': !stats.advanced }"
        >
          <i class="far fa-comment fa-2x pt-2" /><br />
          <span class="inline-block pb-2 align-middle text-lg"
            >Nachrichten</span
          >
          <span
            v-if="stats.messages > 0"
            class="bg-red-500 rounded-full absolute p-1 -top-2 -right-2"
            >{{ stats.messages }}</span
          >
        </div>
        <div
          v-if="!offline"
          class="dashboardtile"
          onclick="window.location='/archive'"
        >
          <i class="fa fa-business-time fa-2x pt-2" /><br />
          <span class="inline-block pb-2 align-middle text-lg">Archiv</span>
        </div>
        <div
          v-if="!offline"
          class="dashboardtile"
          onclick="window.location='/documents'"
        >
          <i class="far fa-folder fa-2x pt-2" /><br />
          <span class="inline-block pb-2 align-middle text-lg">Dokumente</span>
        </div>
        <div
          v-if="!offline && stats.type == 'internal' && stats.advanced"
          class="dashboardtile md:hidden"
          onclick="window.location='/admin/login'"
        >
          <i class="fa-brands fa-internet-explorer fa-2x pt-2" /><br />
          <span class="inline-block pb-2 align-middle text-lg">Web-Login</span>
        </div>
        <div
          v-if="!offline && stats.advanced"
          class="dashboardtile xl:w-96 w-full"
          onclick="window.location='/admin'"
        >
          <i class="fa fa-sliders fa-2x pt-2" /><br />
          <span class="inline-block pb-2 align-middle text-lg"
            >Admin-Bereich</span
          >
        </div>
        <br />
        <button
          v-if="!offline"
          class="md:hidden mt-10 border-caspyellow text-black bg-caspyellow rounded-lg w-28 xl:w-56 xs:w-72 py-2 border-2 font-bold xl:m-10"
          onclick="window.location='/ID'"
        >
          Dienstausweis
        </button>
        <a
          href="tel:+492233402850"
          class="md:hidden mt-10 rounded-lg w-28 xl:w-56 xs:w-72 py-2 inline-block font-bold border-2 text-white xl:m-10"
          style="background: #ff3a35; border: #ff3a35"
        >
          Rufbereitschaft
        </a>
        <div v-if="!offline" class="w-full text-center hidden md:inline-block">
          <button
            class="mt-5 rounded-lg w-28 xl:w-56 bg-red-500 xs:w-72 py-2 font-bold border-2 text-white xl:m-10"
            :disabled="loading"
            @click="logoutWeb()"
          >
            {{ stats.impersonating ? "Ausloggen (Admin)" : "Ausloggen" }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <span class="fixed bottom-0 right-0 p-2 text-gray-400 text-sm z-30">v{{ appVersion }}</span>
  <div
    class="md:hidden bg-gray-50 border-t border-t-gray-300 fixed bottom-0 w-full text-center xl:hidden"
    onclick="window.location='/settings'"
  >
    <span class="inline-block py-2 text-iosblue font-medium"
      >Einstellungen</span
    >
  </div>

  <!-- Email Input Modal -->
  <div v-if="showMailInput" class="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
    <div class="bg-white p-6 rounded-lg shadow-xl text-left max-w-sm w-full">
        <h3 class="text-lg font-bold mb-4">E-Mail-Adresse benötigt</h3>
        <p class="mb-4 text-sm">Wir benötigen Ihre E-Mail-Adresse, um Ihnen wichtige Dokumente wie Abrechnungen zusenden zu können. Ihre Daten werden vertraulich behandelt.</p>
        <input type="email" v-model="email" placeholder="Ihre E-Mail-Adresse" class="w-full p-2 border border-gray-300 rounded mb-4" />
        <div class="flex justify-end space-x-4">
            <button @click="dismissEmailModal" class="px-4 py-2 rounded text-gray-600 bg-gray-200 hover:bg-gray-300">Später erinnern</button>
            <button @click="submitEmail" class="px-4 py-2 rounded text-white bg-blue-500 hover:bg-blue-600">Speichern</button>
        </div>
    </div>
  </div>
</template>
<script>
import CASP from "../CASP";
import Spinner from "@/components/Spinner";
import { useCookies } from "vue3-cookies";

export default {
  name: "MainDashboard",
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  data() {
    return {
      window: window,
      stats: {},
      offline: false,
      advanced: false,
      loading: false,
      showMailInput: false,
      email: "",
    };
  },
  computed: {
    appVersion() {
      return process.env.VUE_APP_VERSION || 'dev';
    }
  },
  components: { Spinner },
  methods: {
    submitEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.email || !emailRegex.test(this.email)) {
        alert("Bitte geben Sie eine gültige E-Mail-Adresse ein.");
        return;
      }
      CASP.changeUserWithStatus(this.stats.user.id, { email: this.email }, (status, response) => {
        if (status === 200) {
          this.showMailInput = false;
          this.getStats(); // Refresh stats to get updated user info
        } else {
          alert("Fehler beim Speichern der E-Mail-Adresse.");
        }
      });
    },
    dismissEmailModal() {
      const expiryDate = new Date();
      expiryDate.setTime(expiryDate.getTime() + (30 * 60 * 1000)); // 30 minutes
      this.cookies.set("dismissedEmailModal", "true", expiryDate);
      this.showMailInput = false;
    },
    logoutWeb() {
      if (this.stats.impersonating) {
        const token = this.cookies.get("caspauth") || this.cookies.get("authtoken");
        CASP.stopImpersonation(token, (status) => {
          if (status === 200) {
            if (localStorage) localStorage.removeItem("stats");
            window.location = "/admin/employees";
          } else {
            alert("Die Admin-Identität konnte nicht wiederhergestellt werden.");
          }
        });
        return;
      }
      CASP.logoutWeb((status) => {
        if (status === 200) {
          this.cookies.remove("caspauth");
          this.cookies.remove("authtoken");
          if (localStorage) localStorage.removeItem("stats");
          window.location = "/forbidden";
        } else if (status === 409) {
          this.getStats();
          alert("Die Sitzung wird als Admin verwendet. Bitte erneut versuchen.");
        } else {
          alert("Das Ausloggen ist fehlgeschlagen.");
        }
      });
    },
    getStats() {
      this.loading = true;
      CASP.getStats((status, response) => {
        this.loading = false;
        if (status == 401) {
          window.location = "/forbidden";
        } else if (status == 200) {
          this.offline = false;
          this.stats = response;
          if (this.stats.type == "external") {
            this.window.location = "/admin";
          }
          this.advanced = this.stats.advanced;
          const dismissed = this.cookies.get("dismissedEmailModal");
          if (!this.stats.user.email && !dismissed) {
            this.showMailInput = true;
            this.email = "";
          }
        } else {
          // get stats from local
          if (localStorage && localStorage.getItem("stats")) {
            this.stats = JSON.parse(localStorage.getItem("stats"));
            this.offline = true;
          } else {
            window.location = "/forbidden";
          }
        }
      });
    },
  },
  created: function () {
    document.getElementById("mainspinner").style.display = "none";
    this.token = this.cookies.get("caspauth") || this.cookies.get("authtoken");
    this.getStats();
    if (localStorage) localStorage.setItem("last", "/");
  },
};
</script>

<style scoped>
.main-dashboard-header {
  display: none;
}

@media (min-width: 768px) {
  .main-dashboard-header {
    width: min(80rem, calc(100% - 3rem));
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
    margin: 1.5rem auto 0;
    padding: 1.25rem 1.5rem;
    border: 1px solid #d9dee7;
    border-radius: 0.8rem;
    background: #ffffff;
    box-shadow: 0 8px 24px rgba(23, 26, 31, 0.07);
    text-align: left;
  }

  .main-dashboard-header__kicker {
    display: block;
    color: #626b7a;
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .main-dashboard-header__title {
    margin: 0.15rem 0 0;
    color: #171a1f;
    font-size: 2rem;
    font-weight: 800;
    line-height: 1.1;
  }

  .main-dashboard-header__subtitle {
    margin: 0.45rem 0 0;
    color: #626b7a;
    font-size: 0.95rem;
  }

  .main-dashboard-header__icon {
    display: flex;
    width: 3.5rem;
    height: 3.5rem;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    border-radius: 0.9rem;
    background: #feed01;
    color: #171a1f;
    font-size: 1.45rem;
  }
}
</style>
